import React, { useCallback } from 'react';
import styles from './card.module.scss';
import { Link } from 'react-router-dom';
import { getMediaAbsolutePath } from '@services/File';
import FlagAU from 'src/assets/icons/icon_au.svg?react';
import FlagCA from 'src/assets/icons/icon_ca.svg?react';
import FlagUS from 'src/assets/icons/icon_us.svg?react';
import Customized from 'src/assets/icons/customized.svg?react';
import Checkbox from 'src/components/checkbox/Checkbox';

const getFlagIcon = (type: String) => {
  switch (type) {
    case "Australia": {
      return <FlagAU />
    }
    case "Canada": {
      return <FlagCA />
    }
    case "USA": {
      return <FlagUS />
    }
    case "Canada & USA": {
      return <>
        <FlagCA /> <FlagUS />
      </>
    }
    default: {
      return null;
    }
  }
}

type Props = {
  flag: String;
  program: any;
  access: boolean;
  customize: boolean;
  onChange: (name: string, value: boolean) => void;
};

function Card(props: Props) {
  const {
    flag,
    program,
    access,
    customize,
    onChange,
  } = props;

  const { name, image, customized } = program;

  const link = `/super/courses/customize`;

  const handleChangeCustomize = useCallback((v: boolean) => {
    onChange('customize', v);
  }, [onChange]);

  const handleChangeAccess = useCallback((v: boolean) => {
    onChange('access', v);
  }, [onChange]);

  return (
    <article className={styles.card}>
      <Link to={link} className={styles.image}
            style={{ backgroundImage: `url(${image ? getMediaAbsolutePath(image) : ''})` }}/>
      <section className={styles.content}>
        <div className={styles.title}>{name}</div>
        <div>
          {getFlagIcon(`${flag}`)}
        </div>
        <div className={styles.iconWrapper}>
          <Checkbox id={'access'} checked={access} label={''} onChange={handleChangeAccess}/>
        </div>
        <div className={styles.iconWrapper}>
          <div className={styles.courseAction}>
            {customized ? <div className={`${styles.status}`}>
              <Customized></Customized>{'Customized'}
            </div> : null}
          </div>
        </div>
        <div className={styles.iconWrapper}>
          <Checkbox id={'customize'} checked={customize} label={''} onChange={handleChangeCustomize}/>
        </div>
      </section>
    </article>
  );
}

export default Card;
